import { useNavigate } from "react-router-dom";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import { HiChevronRight } from "react-icons/hi2";
import clsx from "clsx";
import { ReviewDiscoveryListQuery } from "../../../__generated__/graphql";
import { track } from "@amplitude/analytics-browser";

type ReviewDiscovery = NonNullable<
  ReviewDiscoveryListQuery["reviewDiscoveryList"]
>[number];

interface StoreOverviewCardProps {
  review: ReviewDiscovery;
}

const StoreOverviewCard: React.FC<StoreOverviewCardProps> = ({ review }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        track("찐후기 매장 상세보기 클릭");
        navigate(`/store/${review?.store?.id}`);
      }}
      className="w-full flex gap-3 bg-white rounded-lg p-3 cursor-pointer hover:bg-gray-50 transition-colors"
    >
      <div className="w-14 h-14 rounded-lg bg-gray-100 overflow-hidden flex-shrink-0">
        {review?.store?.img && (
          <ResponsiveCDNImage
            src={review?.store?.img}
            alt="매장 이미지"
            className="w-full h-full object-cover"
            lazy
          />
        )}
      </div>
      <div className="flex-1 flex justify-between items-center min-w-0">
        <div className="flex-1 flex flex-col gap-1 min-w-0">
          <div className="flex items-center gap-2">
            <div className="text-black font-medium truncate">
              {review?.store?.title}
            </div>
            <div className="text-gray-500 text-sm">
              {review?.store?.distance
                ? review?.store?.distance < 1
                  ? (review?.store?.distance * 1000).toFixed(0) + "m"
                  : review?.store?.distance.toFixed(2) + "km"
                : ""}
            </div>
          </div>
          <div className="flex items-baseline gap-2">
            <div className="line-through text-gray-500 text-sm">
              {(
                (review?.order?.amount ?? 0) +
                (review?.order?.totalDiscount ?? 0)
              ).toLocaleString()}
              원
            </div>
            <div className="flex items-baseline gap-1">
              <div
                className={clsx(
                  "font-medium",
                  review?.orderType === "PACK"
                    ? "text-green-500"
                    : "text-blue-500"
                )}
              >
                {review?.order?.amount?.toLocaleString()}원
              </div>
              <div className="text-gray-800 text-sm">
                ({review?.order?.totalQuantity}개 구매)
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center text-gray-400 ml-2">
          <HiChevronRight className="w-6 h-6" />
        </div>
      </div>
    </div>
  );
};

export default StoreOverviewCard;
